<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/P2q4U1/tc-custom/9781460379547.jpg?1740434632471" alt="This image is the cover for the book His Secret Son, The Pirelli Brothers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Secret Son, The Pirelli Brothers
      </h1>
      <p class="bookDescription body article font2">
        <p>That was then <br/><br/>Ten years ago, getting up close and personal with Ryder Kincaid was all Lindsay Brookes wanted. The bookish senior couldn't believe it when the gorgeous Clearville High football hero finally noticed her. One magical night together was all it took to change her world. Now the single mom is coming hometo come clean with the guy she's never gotten over. <br/><br/>Could this be their now? <br/><br/>The stunning brunette with the shy nine-year-old kid isLindsay? Ryder never forgot how she gave herself to him so completely. But he's changeda lot. And the secret Lindsay's keeping could tear them apart. With desire reignitingand then some!this could be Ryder's chance to step up and become the husband and father he always wanted to bewith the woman he's never stopped wanting</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stacy Connelly
      </h2>
      
      <p class="authorDescription body article">Stacy Connelly dreamed of publishing books since she was a kid writing about a girl and her horse. Eventually, boys made it onto the page as she discovered a love of romance and the promise of happily-ever-after. <Br><Br>In 2008, that dream came true when she sold All She Wants for Christmas to Silhouette Special Edition. <Br><Br>When she is not lost in the land of make-believe, Stacy lives in Arizona with her two spoiled dogs.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a400b01